const AlertFilterItems = {
  alert: 'Alerts',
  history: 'History',
} as const;

export type ConversationItem = keyof typeof AlertFilterItems;

export default AlertFilterItems;
